<div class="tenant-dialog-container">
  <div class="dialog-header">
    <h2 class="dialog-title"><b>Tenant Information</b></h2>
    <button
      mat-icon-button
      (click)="closeDialog()"
      aria-label="Close dialog"
    >
      <mat-icon>{{ ICONS.CLOSE }}</mat-icon>
    </button>
  </div>

  <div class="dialog-content">
    <!-- Warning/Reminder Section -->
    <div class="reminder-section">
      <div class="reminder-icon">
        <mat-icon class="icon-warning">{{ ICONS.INFO }}</mat-icon>
      </div>
      <div class="reminder-content">
        <p class="reminder-title"><strong>Important Reminder</strong></p>
        <p class="reminder-text">
          As we are switching the tenant, please ensure all active tabs are
          closed. Please save any unsaved work before proceeding.
        </p>
      </div>
    </div>

    <div
      *ngIf="tenantList.length === 0"
      class="no-tenants"
    >
      <p>No tenant information available.</p>
    </div>

    <div
      *ngIf="tenantList.length > 0"
      class="tenant-selection-container"
    >
      <!-- Tenant Dropdown -->
      <div class="dropdown-section">
        <label class="dropdown-label">Select Tenant:</label>
        <mat-select
          [(value)]="selectedTenant"
          (selectionChange)="onTenantChange($event.value)"
          class="tenant-dropdown"
          hideSingleSelectionIndicator
        >
          <mat-option
            *ngFor="let tenant of tenantList"
            [value]="tenant"
            [disabled]="
              currentTenant && tenant.tenant_name === currentTenant.tenantName
            "
          >
            <div class="tenant-option">
              <span class="option-name">
                {{ tenant.tenant_name }}
              </span>
            </div>
          </mat-option>
        </mat-select>
      </div>

      <!-- Selected Tenant Details -->
      <div
        *ngIf="selectedTenant"
        class="tenant-details"
      >
        <div class="tenant-info-header">
          <h3 class="selected-tenant-name">{{ selectedTenant.tenant_name }}</h3>
          <span class="selected-tenant-type">
            {{ selectedTenant.tenant_type }}
          </span>
        </div>
      </div>
    </div>
  </div>

  <div class="dialog-footer">
    <div class="footer-buttons">
      <button
        class="cancel-button"
        (click)="closeDialog()"
      >
        Cancel
      </button>
      <button
        class="switch-button"
        (click)="switchTenant()"
        [disabled]="!selectedTenant || isCurrentTenant()"
      >
        Switch Tenant
      </button>
    </div>
  </div>
</div>
